// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderInstitutionalClaim,
    ProviderInstitutionalClaimTemplate,
    ProviderInstitutionalSortType,
    SupportCreateInstitutionalClaimPayload,
    SupportCreateInstitutionalClaimTemplatePayload,
    SupportInstitutionalClaim,
    SupportInstitutionalClaimTemplate,
    SupportInstitutionalSortType,
    SupportInstitutionalTemplateSortType,
    SupportPatchInstitutionalClaimTemplatePayload,
    SupportUpdateInstitutionalClaimCollectionMemoPayload,
    SupportUpdateInstitutionalClaimPayload,
    SupportUpdateInstitutionalClaimTemplatePayload,
    SupportCreateInstitutionalClaimPayloadToJSON,
    SupportCreateInstitutionalClaimTemplatePayloadToJSON,
    SupportPatchInstitutionalClaimTemplatePayloadToJSON,
    SupportUpdateInstitutionalClaimCollectionMemoPayloadToJSON,
    SupportUpdateInstitutionalClaimPayloadToJSON,
    SupportUpdateInstitutionalClaimTemplatePayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderInstitutionalClaimFromJSON,
    ProviderInstitutionalClaimTemplateFromJSON,
    SupportInstitutionalClaimFromJSON,
    SupportInstitutionalClaimTemplateFromJSON,
} from '../models';

export interface CreateSupportInstitutionalClaimRequest {
    supportCreateInstitutionalClaimPayload: SupportCreateInstitutionalClaimPayload;
}

export interface CreateSupportInstitutionalClaimTemplateRequest {
    supportCreateInstitutionalClaimTemplatePayload: SupportCreateInstitutionalClaimTemplatePayload;
}

export interface DisableSupportInstitutionalClaimRequest {
    id: string;
}

export interface GetProviderInstitutionalClaimRequest {
    id: string;
}

export interface GetProviderInstitutionalClaimTemplateRequest {
    id: string;
}

export interface GetSupportInstitutionalClaimRequest {
    id: string;
}

export interface GetSupportInstitutionalClaimTemplateRequest {
    id: string;
}

export interface ListProviderInstitutionalClaimsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderInstitutionalClaimsOrderEnum>;
    filterCreated?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSellerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClaimId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    sort?: Array<ProviderInstitutionalSortType>;
}

export interface ListSupportInstitutionalClaimTemplatesRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportInstitutionalClaimTemplatesOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterName?: Array<string>;
    sort?: Array<SupportInstitutionalTemplateSortType>;
}

export interface ListSupportInstitutionalClaimsRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportInstitutionalClaimsOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterPayerId?: Array<string>;
    filterSubscriberId?: Array<string>;
    filterPatientId?: Array<string>;
    filterFacilityId?: Array<string>;
    filterProviderId?: Array<string>;
    filterSellerId?: Array<string>;
    filterPaymentId?: Array<string>;
    filterClaimId?: Array<string>;
    filterFirst?: Array<string>;
    filterLast?: Array<string>;
    filterFirstLast?: Array<string>;
    filterDiagnosis?: Array<string>;
    filterPriorAuthorizationNumber?: Array<string>;
    filterCharge?: Array<string>;
    filterFromDos?: Array<string>;
    filterThroughDos?: Array<string>;
    filterProcedure?: Array<string>;
    filterModifier?: Array<string>;
    filterServiceCharge?: Array<string>;
    sort?: Array<SupportInstitutionalSortType>;
}

export interface PatchSupportInstitutionalClaimTemplateRequest {
    id: string;
    supportPatchInstitutionalClaimTemplatePayload: SupportPatchInstitutionalClaimTemplatePayload;
}

export interface PostSupportInstitutionalClaimCollectionMemoRequest {
    id: string;
    supportUpdateInstitutionalClaimCollectionMemoPayload: SupportUpdateInstitutionalClaimCollectionMemoPayload;
}

export interface UpdateSupportInstitutionalClaimRequest {
    id: string;
    supportUpdateInstitutionalClaimPayload: SupportUpdateInstitutionalClaimPayload;
}

export interface UpdateSupportInstitutionalClaimTemplateRequest {
    id: string;
    supportUpdateInstitutionalClaimTemplatePayload: SupportUpdateInstitutionalClaimTemplatePayload;
}

/**
 * no description
 */
export class InstitutionalApi extends runtime.BaseAPI {

    /**
     * Create a institutional claim
     * Create a institutional claim
     */
    async createSupportInstitutionalClaimRaw(requestParameters: CreateSupportInstitutionalClaimRequest): Promise<runtime.ApiResponse<SupportInstitutionalClaim>> {
        if (requestParameters['supportCreateInstitutionalClaimPayload'] === null || requestParameters['supportCreateInstitutionalClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateInstitutionalClaimPayload','Required parameter requestParameters.supportCreateInstitutionalClaimPayload was null or undefined when calling createSupportInstitutionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateInstitutionalClaimPayloadToJSON(requestParameters['supportCreateInstitutionalClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInstitutionalClaimFromJSON(jsonValue));
    }

    /**
     * Create a institutional claim
     * Create a institutional claim
     */
    async createSupportInstitutionalClaim(requestParameters: CreateSupportInstitutionalClaimRequest): Promise<SupportInstitutionalClaim> {
        const response = await this.createSupportInstitutionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Create a institutional claim template
     * Create a institutional claim template
     */
    async createSupportInstitutionalClaimTemplateRaw(requestParameters: CreateSupportInstitutionalClaimTemplateRequest): Promise<runtime.ApiResponse<SupportInstitutionalClaimTemplate>> {
        if (requestParameters['supportCreateInstitutionalClaimTemplatePayload'] === null || requestParameters['supportCreateInstitutionalClaimTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateInstitutionalClaimTemplatePayload','Required parameter requestParameters.supportCreateInstitutionalClaimTemplatePayload was null or undefined when calling createSupportInstitutionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateInstitutionalClaimTemplatePayloadToJSON(requestParameters['supportCreateInstitutionalClaimTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInstitutionalClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Create a institutional claim template
     * Create a institutional claim template
     */
    async createSupportInstitutionalClaimTemplate(requestParameters: CreateSupportInstitutionalClaimTemplateRequest): Promise<SupportInstitutionalClaimTemplate> {
        const response = await this.createSupportInstitutionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a institutional claim
     * Disable a institutional claim
     */
    async disableSupportInstitutionalClaimRaw(requestParameters: DisableSupportInstitutionalClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportInstitutionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a institutional claim
     * Disable a institutional claim
     */
    async disableSupportInstitutionalClaim(requestParameters: DisableSupportInstitutionalClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportInstitutionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an institutional
     * Get an institutional claim
     */
    async getProviderInstitutionalClaimRaw(requestParameters: GetProviderInstitutionalClaimRequest): Promise<runtime.ApiResponse<ProviderInstitutionalClaim>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderInstitutionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/institutional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderInstitutionalClaimFromJSON(jsonValue));
    }

    /**
     * Gets an institutional
     * Get an institutional claim
     */
    async getProviderInstitutionalClaim(requestParameters: GetProviderInstitutionalClaimRequest): Promise<ProviderInstitutionalClaim> {
        const response = await this.getProviderInstitutionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a institutional claim template
     * Get a institutional claim template
     */
    async getProviderInstitutionalClaimTemplateRaw(requestParameters: GetProviderInstitutionalClaimTemplateRequest): Promise<runtime.ApiResponse<ProviderInstitutionalClaimTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderInstitutionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/institutional/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderInstitutionalClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Gets a institutional claim template
     * Get a institutional claim template
     */
    async getProviderInstitutionalClaimTemplate(requestParameters: GetProviderInstitutionalClaimTemplateRequest): Promise<ProviderInstitutionalClaimTemplate> {
        const response = await this.getProviderInstitutionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets an institutional
     * Get an institutional claim
     */
    async getSupportInstitutionalClaimRaw(requestParameters: GetSupportInstitutionalClaimRequest): Promise<runtime.ApiResponse<SupportInstitutionalClaim>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportInstitutionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInstitutionalClaimFromJSON(jsonValue));
    }

    /**
     * Gets an institutional
     * Get an institutional claim
     */
    async getSupportInstitutionalClaim(requestParameters: GetSupportInstitutionalClaimRequest): Promise<SupportInstitutionalClaim> {
        const response = await this.getSupportInstitutionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a institutional claim template
     * Get a institutional claim template
     */
    async getSupportInstitutionalClaimTemplateRaw(requestParameters: GetSupportInstitutionalClaimTemplateRequest): Promise<runtime.ApiResponse<SupportInstitutionalClaimTemplate>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportInstitutionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportInstitutionalClaimTemplateFromJSON(jsonValue));
    }

    /**
     * Gets a institutional claim template
     * Get a institutional claim template
     */
    async getSupportInstitutionalClaimTemplate(requestParameters: GetSupportInstitutionalClaimTemplateRequest): Promise<SupportInstitutionalClaimTemplate> {
        const response = await this.getSupportInstitutionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of institutional claims
     * Get a list of institutional claims
     */
    async listProviderInstitutionalClaimsRaw(requestParameters: ListProviderInstitutionalClaimsRequest): Promise<runtime.ApiResponse<Array<ProviderInstitutionalClaim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/institutional`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderInstitutionalClaimFromJSON));
    }

    /**
     * Gets a list of institutional claims
     * Get a list of institutional claims
     */
    async listProviderInstitutionalClaims(requestParameters: ListProviderInstitutionalClaimsRequest): Promise<Array<ProviderInstitutionalClaim>> {
        const response = await this.listProviderInstitutionalClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of institutional claim templates
     * Get a list of institutional claim templates
     */
    async listSupportInstitutionalClaimTemplatesRaw(requestParameters: ListSupportInstitutionalClaimTemplatesRequest): Promise<runtime.ApiResponse<Array<SupportInstitutionalClaimTemplate>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterName) {
            queryParameters['filterName'] = requestParameters.filterName;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportInstitutionalClaimTemplateFromJSON));
    }

    /**
     * Gets a list of institutional claim templates
     * Get a list of institutional claim templates
     */
    async listSupportInstitutionalClaimTemplates(requestParameters: ListSupportInstitutionalClaimTemplatesRequest): Promise<Array<SupportInstitutionalClaimTemplate>> {
        const response = await this.listSupportInstitutionalClaimTemplatesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of institutional claims
     * Get a list of institutional claims
     */
    async listSupportInstitutionalClaimsRaw(requestParameters: ListSupportInstitutionalClaimsRequest): Promise<runtime.ApiResponse<Array<SupportInstitutionalClaim>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterSubscriberId) {
            queryParameters['filterSubscriberId'] = requestParameters.filterSubscriberId;
        }

        if (requestParameters.filterPatientId) {
            queryParameters['filterPatientId'] = requestParameters.filterPatientId;
        }

        if (requestParameters.filterFacilityId) {
            queryParameters['filterFacilityId'] = requestParameters.filterFacilityId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.filterSellerId) {
            queryParameters['filterSellerId'] = requestParameters.filterSellerId;
        }

        if (requestParameters.filterPaymentId) {
            queryParameters['filterPaymentId'] = requestParameters.filterPaymentId;
        }

        if (requestParameters.filterClaimId) {
            queryParameters['filterClaimId'] = requestParameters.filterClaimId;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.filterDiagnosis) {
            queryParameters['filterDiagnosis'] = requestParameters.filterDiagnosis;
        }

        if (requestParameters.filterPriorAuthorizationNumber) {
            queryParameters['filterPriorAuthorizationNumber'] = requestParameters.filterPriorAuthorizationNumber;
        }

        if (requestParameters.filterCharge) {
            queryParameters['filterCharge'] = requestParameters.filterCharge;
        }

        if (requestParameters.filterFromDos) {
            queryParameters['filterFromDos'] = requestParameters.filterFromDos;
        }

        if (requestParameters.filterThroughDos) {
            queryParameters['filterThroughDos'] = requestParameters.filterThroughDos;
        }

        if (requestParameters.filterProcedure) {
            queryParameters['filterProcedure'] = requestParameters.filterProcedure;
        }

        if (requestParameters.filterModifier) {
            queryParameters['filterModifier'] = requestParameters.filterModifier;
        }

        if (requestParameters.filterServiceCharge) {
            queryParameters['filterServiceCharge'] = requestParameters.filterServiceCharge;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportInstitutionalClaimFromJSON));
    }

    /**
     * Gets a list of institutional claims
     * Get a list of institutional claims
     */
    async listSupportInstitutionalClaims(requestParameters: ListSupportInstitutionalClaimsRequest): Promise<Array<SupportInstitutionalClaim>> {
        const response = await this.listSupportInstitutionalClaimsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Patch a institutional claim template
     * Patch a institutional claim template
     */
    async patchSupportInstitutionalClaimTemplateRaw(requestParameters: PatchSupportInstitutionalClaimTemplateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling patchSupportInstitutionalClaimTemplate.');
        }

        if (requestParameters['supportPatchInstitutionalClaimTemplatePayload'] === null || requestParameters['supportPatchInstitutionalClaimTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportPatchInstitutionalClaimTemplatePayload','Required parameter requestParameters.supportPatchInstitutionalClaimTemplatePayload was null or undefined when calling patchSupportInstitutionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: SupportPatchInstitutionalClaimTemplatePayloadToJSON(requestParameters['supportPatchInstitutionalClaimTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Patch a institutional claim template
     * Patch a institutional claim template
     */
    async patchSupportInstitutionalClaimTemplate(requestParameters: PatchSupportInstitutionalClaimTemplateRequest): Promise<ObjectNoResponse> {
        const response = await this.patchSupportInstitutionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

    /**
     * Post a collection memo
     * Post a collection memo
     */
    async postSupportInstitutionalClaimCollectionMemoRaw(requestParameters: PostSupportInstitutionalClaimCollectionMemoRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling postSupportInstitutionalClaimCollectionMemo.');
        }

        if (requestParameters['supportUpdateInstitutionalClaimCollectionMemoPayload'] === null || requestParameters['supportUpdateInstitutionalClaimCollectionMemoPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateInstitutionalClaimCollectionMemoPayload','Required parameter requestParameters.supportUpdateInstitutionalClaimCollectionMemoPayload was null or undefined when calling postSupportInstitutionalClaimCollectionMemo.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/{id}/collection_memo`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateInstitutionalClaimCollectionMemoPayloadToJSON(requestParameters['supportUpdateInstitutionalClaimCollectionMemoPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Post a collection memo
     * Post a collection memo
     */
    async postSupportInstitutionalClaimCollectionMemo(requestParameters: PostSupportInstitutionalClaimCollectionMemoRequest): Promise<ObjectNoResponse> {
        const response = await this.postSupportInstitutionalClaimCollectionMemoRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update an institutional claim
     * Update an institutional claim
     */
    async updateSupportInstitutionalClaimRaw(requestParameters: UpdateSupportInstitutionalClaimRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportInstitutionalClaim.');
        }

        if (requestParameters['supportUpdateInstitutionalClaimPayload'] === null || requestParameters['supportUpdateInstitutionalClaimPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateInstitutionalClaimPayload','Required parameter requestParameters.supportUpdateInstitutionalClaimPayload was null or undefined when calling updateSupportInstitutionalClaim.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateInstitutionalClaimPayloadToJSON(requestParameters['supportUpdateInstitutionalClaimPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update an institutional claim
     * Update an institutional claim
     */
    async updateSupportInstitutionalClaim(requestParameters: UpdateSupportInstitutionalClaimRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportInstitutionalClaimRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a institutional claim template
     * Update a institutional claim template
     */
    async updateSupportInstitutionalClaimTemplateRaw(requestParameters: UpdateSupportInstitutionalClaimTemplateRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportInstitutionalClaimTemplate.');
        }

        if (requestParameters['supportUpdateInstitutionalClaimTemplatePayload'] === null || requestParameters['supportUpdateInstitutionalClaimTemplatePayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateInstitutionalClaimTemplatePayload','Required parameter requestParameters.supportUpdateInstitutionalClaimTemplatePayload was null or undefined when calling updateSupportInstitutionalClaimTemplate.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:institutional", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/institutional/template/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateInstitutionalClaimTemplatePayloadToJSON(requestParameters['supportUpdateInstitutionalClaimTemplatePayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a institutional claim template
     * Update a institutional claim template
     */
    async updateSupportInstitutionalClaimTemplate(requestParameters: UpdateSupportInstitutionalClaimTemplateRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportInstitutionalClaimTemplateRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderInstitutionalClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportInstitutionalClaimTemplatesOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportInstitutionalClaimsOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
